import Component from '../../shared/component';

export default class AutomaticElementReloader extends Component {
  constructor(element, {intervalDelay}) {
    super(...arguments);

    this.$element = $(element);
    this.intervalDelay = intervalDelay;
    this.action = this.$element.attr('data-action');
    this.bindTimeout();
  }

  bindTimeout() {
    this.timeout = setTimeout(() => {
      if (this.timeout) {
        this.fetchData();
      }
    }, this.intervalDelay);
  }

  unbindEvents() {
    clearTimeout(this.timeout);
    this.timeout = null;
  }

  fetchData() {
    $.get(this.action).done((data) => this.handleAJAXsuccess(data));
  }

  handleAJAXsuccess() {
    this.bindTimeout();
  }
}
